<mat-card class="mb-25 tagus-card">
    <mat-card-header class="border-bottom d-block" matBadgePosition="after" matBadgeColor="accent" matBadgeSize="large">
        <div class="container">
            <div class="header">
                <div class="title-section">
                    <div class="icon badge" [matBadge]="store.computedContractResource().value()?.data?.length ?? '0'">
                        <h5 class="mb-0">Contracts</h5>
                    </div>
                </div>

                <div class="search-controls">
                    <div class="search-container">
                        <form class="search-box position-relative me-15 width-100">
                            <input type="text" class="input-search d-block" placeholder="Search here..">
                            <button type="submit"><i class="ri-search-line"></i></button>
                        </form>
                    </div>
                    <button mat-icon-button matTooltip="Refresh" matTooltipPosition="above"
                        (click)="store.refreshContracts()" class="">
                        <span class="material-symbols-outlined">
                            refresh
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </mat-card-header>
    <mat-card-content>
        <div class="tagus-mat-table mat-elevation-z8" style="overflow-y: hidden;overflow-x: auto;">
            @if(store.computedContractResource().isLoading()){
            <div class="row">
                <div class="col-12 mb-8 overflow-hidden">
                    <div class="fade-in">
                        <ngx-skeleton-loader count="1" [theme]="getTheme()" />
                    </div>
                </div>
            </div>
            }
            <div [ngStyle]="{'display':store.computedContractResource().isLoading()?'none':'block'}">
                <table mat-table [dataSource]="dataSource">

                    <ng-container matColumnDef="contractId">
                        <th mat-header-cell *matHeaderCellDef class="text-start white-space-nowrap">Contract ID</th>
                        <td mat-cell *matCellDef="let element" class="text-start">
                            <div class="d-flex align-items-center user-info">

                                <div class="title">
                                    <span class="muted-color fw-normal d-block">{{element.terms[0]?.['contractID'] ??
                                        '--' | shortenId:8:8 }}</span>
                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="productCategory">
                        <th mat-header-cell *matHeaderCellDef class="text-start white-space-nowrap">Product Category
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-start">
                            <div class="d-flex align-items-center user-info">

                                <div class="title">
                                    <span class="muted-color fw-normal d-block">{{element.selection?.['productCategory']
                                        ??
                                        '--'}}</span>
                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="contractType">
                        <th mat-header-cell *matHeaderCellDef class="text-start white-space-nowrap">Contract Type</th>
                        <td mat-cell *matCellDef="let element" class="text-start">
                            <div class="d-flex align-items-center user-info">

                                <div class="title">
                                    <span class="muted-color fw-normal d-block">{{element.terms[0]?.['contractType'] ??
                                        '--'}}</span>
                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="statusDate">
                        <th mat-header-cell *matHeaderCellDef class="text-start white-space-nowrap">Status Date</th>
                        <td mat-cell *matCellDef="let element" class="text-start">
                            <div class="d-flex align-items-center user-info">

                                <div class="title">
                                    <span class="muted-color fw-normal d-block">{{element.terms[0]?.['statusDate'] ??
                                        '--'}}</span>
                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="contractRole">
                        <th mat-header-cell *matHeaderCellDef class="text-start white-space-nowrap">Contract Role</th>
                        <td mat-cell *matCellDef="let element" class="text-start">
                            <div class="d-flex align-items-center user-info">

                                <div class="title">
                                    <span class="muted-color fw-normal d-block">{{element.terms[0]?.['contractRole'] ??
                                        '--'}}</span>
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <!-- 
                    <ng-container matColumnDef="productName">
                        <th mat-header-cell *matHeaderCellDef class="white-space-nowrap">Product Name</th>
                        <td mat-cell *matCellDef="let element"><a href="mailto:">{{element.selection.productCategory ??
                                '--'}}</a></td>
                    </ng-container>
    
                    <ng-container matColumnDef="notional">
                        <th mat-header-cell *matHeaderCellDef class="white-space-nowrap">Notional Principal</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="role-info position-relative">
                                {{element.terms[0]?.['notionalPrincipal'] ?? '--'}}
                            </div>
                        </td>
                    </ng-container>
    
                    <ng-container matColumnDef="currency">
                        <th mat-header-cell *matHeaderCellDef>Currency</th>
                        <td mat-cell *matCellDef="let element">
                            <span class="pe-0">{{element.terms[0]?.['currency'] ??
                                '--'}}</span>
                        </td>
                    </ng-container> -->

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="cursor-pointer" tabindex=""
                        (click)="showEvents(row)"></tr>

                </table>
                <mat-paginator [pageSizeOptions]="[4, 8, 12]" showFirstLastButtons>
                </mat-paginator>

            </div>
        </div>
    </mat-card-content>
</mat-card>